export enum SegmentType {
  Component = 0,
  Group = 1,
  Msg = 2,
  Gap = 3,
  Batch = 4,
  Unknown = 5
}
